import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-10">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-full mb-3 whitespace-nowrap">
              Categories
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-900 font-semibold leading-tight">
              Shop All Categories
            </h2>
          </div>
          <p className="text-foreground-500 text-sm max-w-md">
            Browse every product category in our CSSBuy Spreadsheet — each linking directly to verified listings on our main store.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat, idx) => {
            const isLarge = idx === 0;
            return (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className={`group relative flex flex-col items-center justify-center gap-3 p-4 md:p-5 rounded-xl border border-background-200/70 bg-white hover:bg-background-100 transition-all duration-200 cursor-pointer ${
                  isLarge ? 'lg:col-span-2 lg:row-span-2' : ''
                }`}
              >
                <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-200">
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </span>
                <span className="text-xs md:text-sm font-medium text-foreground-800 text-center truncate group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </span>
                {isLarge && (
                  <span className="text-[10px] text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    Most Popular
                  </span>
                )}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}